import { createSlice } from "@reduxjs/toolkit";

export const audioCallSlice = createSlice({
  name: "audioCall",
  initialState: {
    callStatus: "idle", // idle | ringing_customer | connected | feedback
    phoneNumber: "",
    customerName: "",
    purchaseCode: "",
    callDuration: 0,
    agentDisplayName: "",
    popoverOpen: false,
    feedbackData: {
      disposition1: "",
      disposition2: "",
      disposition3: "",
      callback_date: "",
      callnotes: "",
    },
    feedbackLoading: false,
    loading: false,
    error: null,
    isConfigured: false,
  },
  reducers: {
    // Initiate call
    initiateCall: (state, action) => {
      state.phoneNumber = action.payload.phoneNumber;
      state.customerName = action.payload.customerName || "";
      state.callStatus = "ringing_customer";
      state.popoverOpen = true;
      state.loading = true;
    },
    callConnected: (state) => {
      state.callStatus = "connected";
      state.callDuration = 0;
      state.loading = false;
    },
    callFailed: (state, action) => {
      state.callStatus = "idle";
      state.phoneNumber = "";
      state.customerName = "";
      state.popoverOpen = false;
      state.loading = false;
      state.error = action.payload;
    },

    // Hangup
    hangupCall: (state) => {
      state.loading = true;
    },
    hangupSuccess: (state) => {
      state.callStatus = "feedback";
      state.callDuration = 0;
      state.loading = false;
    },

    // Feedback
    submitCallFeedback: (state) => {
      state.feedbackLoading = true;
    },
    feedbackSuccess: (state) => {
      state.callStatus = "idle";
      state.phoneNumber = "";
      state.customerName = "";
      state.purchaseCode = "";
      state.callDuration = 0;
      state.popoverOpen = false;
      state.feedbackLoading = false;
      state.feedbackData = {
        disposition1: "",
        disposition2: "",
        disposition3: "",
        callback_date: "",
        callnotes: "",
      };
    },
    feedbackFailed: (state) => {
      state.feedbackLoading = false;
    },

    // Status check (on page load)
    checkAgentStatus: () => {},
    statusCheckSuccess: (state, action) => {
      const { call_status, current_call, agent_name, is_configured } = action.payload;
      
      // Update isConfigured flag
      if (typeof is_configured === "boolean") {
        state.isConfigured = is_configured;
      }
      
      if (agent_name) {
        state.agentDisplayName = agent_name;
      }
      if (call_status === "on_call" && current_call) {
        state.callStatus = "connected";
        state.customerName = current_call.customer_name || "";
        state.phoneNumber = current_call.customer_mobile_last4
          ? `****${current_call.customer_mobile_last4}`
          : "";
        state.purchaseCode = current_call.purchase_code || "";
        state.callDuration = 0;
        state.popoverOpen = true;
      } else if (call_status === "disposition_pending" && current_call) {
        state.callStatus = "feedback";
        state.customerName = current_call.customer_name || "";
        state.phoneNumber = current_call.customer_mobile_last4
          ? `****${current_call.customer_mobile_last4}`
          : "";
        state.purchaseCode = current_call.purchase_code || "";
        state.popoverOpen = true;
      }
    },

    // UI state
    setPopoverOpen: (state, action) => {
      state.popoverOpen = action.payload;
    },
    setFeedbackData: (state, action) => {
      state.feedbackData = action.payload;
    },
    setCallDuration: (state, action) => {
      state.callDuration = action.payload;
    },
    setAgentDisplayName: (state, action) => {
      state.agentDisplayName = action.payload;
    },
    resetCallState: (state) => {
      state.callStatus = "idle";
      state.phoneNumber = "";
      state.customerName = "";
      state.purchaseCode = "";
      state.callDuration = 0;
      state.popoverOpen = false;
      state.feedbackData = {
        disposition1: "",
        disposition2: "",
        disposition3: "",
        callback_date: "",
        callnotes: "",
      };
      state.feedbackLoading = false;
      state.loading = false;
    },
  },
});

export const {
  initiateCall,
  callConnected,
  callFailed,
  hangupCall,
  hangupSuccess,
  submitCallFeedback,
  feedbackSuccess,
  feedbackFailed,
  checkAgentStatus,
  statusCheckSuccess,
  setPopoverOpen,
  setFeedbackData,
  setCallDuration,
  setAgentDisplayName,
  resetCallState,
} = audioCallSlice.actions;

export default audioCallSlice.reducer;
